import React, { useState } from 'react';
import {
  View,
} from 'react-native';
import {
  Dialog, Portal, IconButton, Button, DataTable,
} from 'react-native-paper';
import { styles } from './QualityGradeInfo.style';

export const qualityGradeColors = {
  A: '#4CAF50', // Green
  B: '#FFC107', // Amber
  C: '#F44336', // Red
};

export const qualityGrades = {
  A: 'Neuf ou quasi neuf',
  B: 'Bon',
  C: 'Mauvais',
};

function QualityGradeInfo() {
  const [infoDialogVisible, setInfoDialogVisible] = useState(false);

  return (
    <View style={styles.container}>
      <IconButton icon="information-outline" onPress={() => setInfoDialogVisible(true)} style={{ marginRight: 0, padding: 0 }} />
      <Portal>
        <Dialog visible={infoDialogVisible} onDismiss={() => setInfoDialogVisible(false)}>
          <Dialog.Title>Etat de qualité</Dialog.Title>
          <Dialog.Content>
            <DataTable style={styles.table}>
              <DataTable.Header>
                <DataTable.Title>Grade</DataTable.Title>
                <DataTable.Title>Description</DataTable.Title>
              </DataTable.Header>

              {Object.entries(qualityGrades).map(([key, value]) => (
                <DataTable.Row key={key}>
                  <DataTable.Cell>{key}</DataTable.Cell>
                  <DataTable.Cell>{value}</DataTable.Cell>
                </DataTable.Row>
              ))}
            </DataTable>
          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={() => setInfoDialogVisible(false)}>Fermer</Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
    </View>
  );
}

export default QualityGradeInfo;
